import React, { useState } from 'react';
import {
  Table,
  Input,
  Pagination,
  Popover,
  Form,
  Empty,
  // DatePicker,
  Row,
  Col,
  Button,
  Space,
} from 'antd';
import {
  // ExportOutlined,
  // FilterOutlined,
  PlusOutlined,
  AppstoreAddOutlined,
  SearchOutlined,
  // CloseOutlined,
  DownloadOutlined,
  ImportOutlined,
} from '@ant-design/icons';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import moment from 'moment';
import formatAmount from 'indian-currency-formatter';

import FilterIconButton from './FilterIconButton';
import ColumnConfig from './ColumnConfig';
import * as Config from '../../appConfig';

import './styles.css';

// const IconList = styled.div`
//   display: flex;
//   justify-content: flex-end;
//   margin-bottom: 1rem;
// `;

const DataGrid = ({
  dataSource,
  columns,
  filters,
  visibleColumns,
  sorting,
  pagination,
  rowSelection,
  rowKey,
  onChange,
  totalRecords,
  onClearFilter,
  onExport,
  onColumnVisibilityUpdate,
  onAddNewEntry,
  addNewEntryBtnLabel,
  onImportMultiplEntry,
  onImportMultiplEntryBtnLabel,
  expandable,
  ...restProps
}) => {
  const [isFiltersChanged, setIsFiltersChanged] = useState(false);
  const [columns2, setColumns2] = useState(columns);
  const [forceRender, setForceRender] = useState(false);
  const [form] = Form.useForm();

  const filterRowKey = 'filter-row--input';
  let dataForFilterRow = { id: filterRowKey };
  columns2.forEach((column) => {
    dataForFilterRow = {
      ...dataForFilterRow,
      [column.key]: filterRowKey,
    };
  });

  const getFormInitialValuesFromFilters = (filters, columns) => {
    let intialValues = {};
    if (filters && filters.length) {
      filters.forEach((i) => {
        // const column = columns.find((j) => j.serverKey === i.column);
        intialValues[i.column] = i.value;
        // column.format === 'date' ? moment(i.value) : i.value;
      });
    }
    return intialValues;
  };

  const getDefaultSortForColumn = (column, sorting) => {
    if (sorting && column.serverKey === sorting.column) {
      return sorting.value === 'ASC' ? 'ascend' : 'descend';
    }
    return false;
  };

  columns2.forEach((column) => {
    const overrideVisibilityFound = visibleColumns.find(
      (i) => i.column === column.serverKey
    );
    if (overrideVisibilityFound) {
      column.visible = overrideVisibilityFound.value;
    }
  });

  const columnsBoostup = columns2
    .filter((i) => i.visible)
    .map((column) => {
      const { render: providedRender = null } = column;
      return {
        ...column,
        sortOrder: getDefaultSortForColumn(column, sorting),
        render: (value, record) => {
          const activeClass =
            filters && filters.find((i) => i.column === column.serverKey)
              ? 'active'
              : '';
          return record[column.key] === filterRowKey ? (
            <>
              {/* {column.format === 'date' && (
                <Form.Item
                  name={column.serverKey}
                  style={{ marginBottom: '0' }}
                >
                  <DatePicker
                    className={`tableColSearch date ${activeClass}`}
                    format={Config.DATE_FORMAT_INPUT}
                    suffixIcon={
                      <SearchOutlined
                        onClick={(e) => {
                          onTableChange(
                            null,
                            {
                              column: column.serverKey,
                              value: form.getFieldValue(column.serverKey),
                            },
                            null,
                            { action: 'filter' }
                          );
                        }}
                      />
                    }
                    placeholder=""
                    allowClear={false}
                    onPressEnter={(e) => {
                      e.preventDefault();
                      onTableChange(
                        null,
                        { column: column.serverKey, value: e.target.value },
                        null,
                        { action: 'filter' }
                      );
                    }}
                    onChange={(value) => {
                      setIsFiltersChanged(true);                     
                    }}
                    onBlur={(e) => {
                      if (isFiltersChanged) {
                        setIsFiltersChanged(false);
                      }
                    }}
                  />
                </Form.Item>
              )} */}
              {column.disableSearch ? (
                ''
              ) : (
                <Form.Item
                  name={column.serverKey}
                  style={{ marginBottom: '0' }}
                >
                  <Input
                    className={`tableColSearch ${activeClass}`}
                    placeholder={column.format === 'date' ? 'DD-MM-YYY' : null}
                    suffix={
                      <SearchOutlined
                        onClick={(e) => {
                          onTableChange(
                            null,
                            {
                              column: column.serverKey,
                              value: form.getFieldValue(column.serverKey),
                            },
                            null,
                            { action: 'filter' }
                          );
                        }}
                      />
                    }
                    onChange={(e) => {
                      setIsFiltersChanged(true);
                    }}
                    onBlur={(e) => {
                      if (isFiltersChanged) {
                        setIsFiltersChanged(false);
                      }
                    }}
                    onPressEnter={(e) => {
                      e.preventDefault();
                      onTableChange(
                        null,
                        { column: column.serverKey, value: e.target.value },
                        null,
                        { action: 'filter' }
                      );
                    }}
                  />
                </Form.Item>
              )}
            </>
          ) : providedRender ? (
            providedRender(value, record)
          ) : column.format && column.format === 'date' && value ? (
            moment(value).format(Config.DATE_FORMAT)
          ) : column.format && column.format === 'month' && value ? (
            moment(value).format(Config.DATE_MONTH_FORMAT)
          ) : column.format && column.format === 'currency' ? (
            value && formatAmount(value)
          ) : (
            value
          );
        },
      };
    });

  console.log('grid:columnsBoostup::/', columnsBoostup);
  console.log('grid:dataForFilterRow::/', dataForFilterRow);
  console.log('grid:dataSource::/', dataSource);

  const onTableChange = (pager, currentFilter, sorter, extra) => {
    console.log('table::onChange::filter /', currentFilter);
    console.log('table::onChange::sorter /', sorter);
    console.log('table::onChange::extra /', extra);
    switch (extra.action) {
      case 'sort':
        let newSorting = {};
        if (typeof sorter.column !== 'undefined') {
          newSorting.column = sorter.column.serverKey;
          newSorting.value = sorter.order === 'descend' ? 'DESC' : 'ASC';
        }
        onChange({ sorting: newSorting });
        break;
      case 'filter':
        let filtersClone = Object.assign([], filters);
        let formFilters = form.getFieldsValue();
        Object.keys(form.getFieldsValue()).forEach((key) => {
          if (typeof formFilters[key] !== 'undefined') {
            let appyFilter = { column: key, value: formFilters[key] };
            const foundIndex = filtersClone.findIndex((i) => i.column === key);

            if (key === currentFilter.column) {
              appyFilter = currentFilter;
            }
            if (foundIndex < 0) {
              filtersClone.push(appyFilter);
            } else {
              filtersClone[foundIndex] = appyFilter;
            }
          }
        });
        onChange({ filters: filtersClone });
        break;
      default:
        break;
    }
  };

  const onColumnUpdate = (columns) => {
    setColumns2(columns);
    setForceRender(!forceRender);
    onColumnVisibilityUpdate(columns);
  };

  const onClearFilterClicked = (filters) => {
    if (filters && filters.length) {
      filters.forEach((filter) => {
        const field = {};
        field[filter.column] = '';
        form.setFieldsValue(field);
      });
      onClearFilter();
    }
  };

  const onExportClicked = () => {
    onExport();
  };

  return (
    <div className="dataGrid">
      <Row>
        <Col xs={24} md={12}></Col>
        <Col
          xs={24}
          md={12}
          style={{ textAlign: 'right', marginBottom: '.5rem' }}
        >
          <Space>
            {onExport && (
              <Button
                type="secondary"
                onClick={onExportClicked}
                icon={<DownloadOutlined />}
              >
                Export
              </Button>
            )}
            {onColumnVisibilityUpdate && (
              <Popover
                placement="bottomRight"
                content={
                  <ColumnConfig
                    columns={columns2}
                    onColumnUpdate={onColumnUpdate}
                  />
                }
                trigger="click"
              >
                <Button type="secondary" icon={<AppstoreAddOutlined />}>
                  Customize
                </Button>
              </Popover>
            )}
            {onImportMultiplEntry && (
              <Button
                type="primary"
                onClick={onImportMultiplEntry}
                icon={<ImportOutlined />}
              >
                {onImportMultiplEntryBtnLabel
                  ? onImportMultiplEntryBtnLabel
                  : 'Import Items'}
              </Button>
            )}
            {onAddNewEntry && (
              <Button
                type="primary"
                onClick={onAddNewEntry}
                icon={<PlusOutlined />}
              >
                {addNewEntryBtnLabel ? addNewEntryBtnLabel : 'Add New Entry'}
              </Button>
            )}
          </Space>
        </Col>
      </Row>

      <Form
        form={form}
        initialValues={getFormInitialValuesFromFilters(filters, columnsBoostup)}
      >
        <Table
          dataSource={
            dataSource && dataSource.length
              ? [dataForFilterRow, ...dataSource]
              : [dataForFilterRow]
          }
          columns={columnsBoostup}
          rowSelection={{
            ...rowSelection,
            renderCell: (checked, record, index, originNode) => {
              return index === 0 ? (
                <FilterIconButton
                  disabled={filters.length <= 0}
                  onClick={() => onClearFilterClicked(filters)}
                />
              ) : rowSelection ? (
                originNode
              ) : null;
            },
          }}
          rowKey={rowKey}
          onChange={onTableChange}
          pagination={false}
          size="middle"
          expandable={expandable}
          className={`${expandable ? 'with-expandable' : ''} ${
            rowSelection ? 'with-row-selection' : ''
          }`}
          {...restProps}
        />
      </Form>

      {dataSource && !dataSource.length && (
        <Empty
          description={<span>Refine your filters to see more result!</span>}
          style={{ marginTop: '2rem', marginBottom: '2rem' }}
        ></Empty>
      )}

      {dataSource && dataSource.length > 0 && (
        <Pagination
          // size="small"
          {...pagination}
          total={totalRecords}
          onChange={(page, pageSize) => {
            onChange({
              pagination: {
                ...pagination,
                page: page,
                current: page,
                pageSize: pageSize,
              },
            });
          }}
          showTotal={(total, range) =>
            `Showing ${range[0]}-${range[1]} of ${total} records`
          }
        />
      )}
    </div>
  );
};

DataGrid.defaultProps = {
  dataSource: [],
  columns: [],
  rowKey: 'id',
  totalRecords: 0,
  onClearFilter: () => {},
  onExport: null,
  onColumnVisibilityUpdate: null,
  onAddNewEntry: null,
  expandable: null,
};

DataGrid.propTypes = {
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired,
  visibleColumns: PropTypes.object.isRequired,
  sorting: PropTypes.object.isRequired,
  pagination: PropTypes.object.isRequired,
  rowSelection: PropTypes.object,
  rowKey: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  totalRecords: PropTypes.number.isRequired,
  onClearFilter: PropTypes.func,
  onExport: PropTypes.func,
  onColumnVisibilityUpdate: PropTypes.func,
  onAddNewEntry: PropTypes.func,
  addNewEntryBtnLabel: PropTypes.string,
  expandable: PropTypes.object,
};

export default DataGrid;
